import { FunctionComponent, useEffect, useMemo, useRef } from "react";

import { usePersonaFilters } from "../utils/usePersonaFilters";
import {
	IPersonaCategoryFilter,
	IPersonaCategoryFilterWithValues,
} from "../constants/general-filter";

export interface JobTitleAutocompleteProps {
	values: string[];
	typeOfValue: IPersonaCategoryFilter;
	handleChange: (value: string[], event?: string) => void;
	isDisabled?: boolean;
}

export const JobTitleAutocomplete: FunctionComponent<JobTitleAutocompleteProps> = ({
	values,
	typeOfValue,
	handleChange,
	isDisabled,
}) => {
	const filter = useMemo(
		() =>
			({
				[typeOfValue.name]: {
					name: typeOfValue.name,
					value: values.map((item) => ({ title: item, id: item })),
					filterParam: typeOfValue.filterParam,
					type: typeOfValue.filterByType,
					customColumnId: typeOfValue.customColumnId,
				},
			}) as IPersonaCategoryFilterWithValues,

		[
			JSON.stringify(values),
			typeOfValue.name,
			typeOfValue.filterParam,
			typeOfValue.filterByType,
			typeOfValue.customColumnId,
		]
	);

	const { renderFilters, filterValue: personaFilterValue } = usePersonaFilters({ filter });

	const valuesRef = useRef(values);

	valuesRef.current = values;

	useEffect(() => {
		const rawValue = personaFilterValue?.[typeOfValue.name]?.value;

		if (!rawValue || !Array.isArray(rawValue)) {
			return;
		}

		const newValues = (rawValue as { title: string }[]).map((item) => item.title);

		if (JSON.stringify([...newValues].sort()) !== JSON.stringify([...valuesRef.current].sort())) {
			handleChange(newValues);
		}
	}, [personaFilterValue]);

	return <>{renderFilters([typeOfValue], undefined, undefined, isDisabled)}</>;
};
